/* ⚛ REACT */
import { useState } from "react";

/* 📦 LIBS */
import { useNavigate } from "react-router";

/* 🧩 COMPONENTS */
import { ItemContainer } from "./components";

import { useTranslation } from "react-i18next";

/* 🧠 REDUX */
import { useSelector } from "react-redux/es/hooks/useSelector";

/* 📁 ASSETS*/
import { BackIcon, ControlIcon, DashIcon, FuncIcon, MaintenanceIcon, MapIcon, OpenIcon, ReportIcon, AdmIcon,
    EquipamentIcon, GraficosIcon, CompararIcon, 
    CenterMobile, Menu, EquipamentsIcon, ContrPerdaIcon, LogIcon, SBDIcon, UserIcon, GoIcon, LogOutIcon} from "../../../../Assets/icons/MenuIcons";

/* 🎨 STYLES */
import { Container, SvgIcon, ExpandedContent, SubitensContainer, ContainerCenter } from "./styles";

import { store } from "../../../../Redux/Store";
import { LogOut } from "../../../../Redux/Actions";


function MenuButton() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const currentPage = window.location.pathname;
    const [isExpanded, setExpanded] = useState(false);
    const [itenstoShow, setItenstoShow] = useState([]);
    const [showSubitens, setShowsubitens] = useState(false);
    const [showPageMenu, setShowPageMenu] = useState(false);
    const equipamento = useSelector(state => state.generalReducer.Equipament);
    const user = useSelector(state => state.userReducer);

    const toggleExpanded = () => {

        if (!isExpanded) {

            if (currentPage.includes('/dashboard')) {
                setItenstoShow(Dashboard);
                setShowsubitens(true);
            }

            else if (currentPage.includes('/historico')) {
                setItenstoShow(Reports);
                setShowsubitens(true);
            }

            else if (currentPage.includes('/manutencoes')) {
                setItenstoShow(Maintenances);
                setShowsubitens(true);
            }

            else if (
                currentPage.includes('/funcionarios') ||
                currentPage.includes('/equipamentos') ||
                currentPage.includes('/logs')
            ) {
                setItenstoShow(Administrativo);
                setShowsubitens(true);
            }

        } else {

            setShowsubitens(false);
            setShowPageMenu(false);

            setTimeout(() => {
                setItenstoShow([]);
            }, 400);
        }

        setExpanded(!isExpanded);
    };

    const ToggleSubitens = (subItens) =>{
        setItenstoShow(subItens)
        setShowsubitens(!showSubitens)
    }

    const hideSubItens = ()=>{
        setShowsubitens(false);
        setTimeout(function(){
            setItenstoShow([]);
        }, 400)
    }

    const TogglePageMenu = () =>{
        setShowPageMenu(!showPageMenu)
    }

    const hidePageMenu = ()=>{
        setShowPageMenu(false);
        setTimeout(() => {}, 400);
    }

    const changePage = (page, props)=>{
        setTimeout(function(){
            setItenstoShow([]);
        }, 400)
        setExpanded(false);
        setShowsubitens(false);
        navigate(page, props);
        
    }

    const Leave = ()=>{
        store.dispatch(LogOut())
    } 

    let Dashboard= [];
        Dashboard.push(
            {
                icon: EquipamentsIcon,
                text: t("dashboards.sub-items.general.sidebar-title"),
                page: equipamento ? `/dashboard/${equipamento}` : `/dashboard`,
                locationFunction : () => {equipamento? changePage(`/dashboard/${equipamento}`) : changePage(`/dashboard`)},
                active: true,
                disabled: false
            }
        )
        Dashboard.push(
            {
                icon: ContrPerdaIcon,
                text: t("dashboards.sub-items.loss-control.sidebar-title"),
                page: '/dashboard/perdas',
                locationFunction : () => {changePage('/dashboard/perdas')},
                active: user?.user?.can?.includes('loss_control.sanep'),
                disabled: !user?.user?.can?.includes('loss_control.sanep')
            }
        )
        Dashboard.push(
            {
                type: 'separator'
            }
        )
        Dashboard.push(
            {
                type: 'separator'
            }
        )
        Dashboard.push(
            {
                type: 'close'
            }
        )
        Dashboard.push(
            {
                type: 'separator'
            }
        )
        Dashboard.push(
            {
                type: 'separator'
            }
        )
        Dashboard.push(
            {
                type: 'separator'
            }
        )  

    let Administrativo = []
    // Adiciona os itens conforme as permissões
    // necessário alterar no menu
        Administrativo.push(
            {
                icon: FuncIcon,
                text: t("administrative.sub-items.employees.sidebar-title"),
                page: '/adm/funcionarios',
                locationFunction: ()=> {changePage('/adm/funcionarios')},
                active: user?.user?.can?.includes('user.view'),
                disabled: !user?.user?.can?.includes('user.view')
            }
        )
        Administrativo.push(
            {
                icon: EquipamentIcon,
                text: t("administrative.sub-items.equipments.sidebar-title"),
                page: '/adm/equipamentos',
                locationFunction: ()=> {changePage('/adm/equipamentos')},
                active: user?.user?.can?.includes('equipment.view'),
                disabled: !user?.user?.can?.includes('equipment.view')
            }
        )
         Administrativo.push(
            {
                icon: LogIcon,
                text: t("administrative.sub-items.logs.sidebar-title"),
                page: '/adm/logs',
                locationFunction: ()=> {changePage('/adm/logs')},
                active: user?.user?.can?.includes('log.view'),
                disabled: !user?.user?.can?.includes('log.view')
            }
        )
        Administrativo.push(
            {
                type: 'separator'
            }
        )
        Administrativo.push(
            {
                type: 'close'
            }
        )
        Administrativo.push(
            {
                type: 'separator'
            }
        )
        Administrativo.push(
            {
                type: 'separator'
            }
        )
        Administrativo.push(
            {
                type: 'separator'
            }
        )

    let Reports = []
        Reports.push(
            {
                icon: GraficosIcon,
                text: t("reports.sub-items.history.sidebar-title"),
                page: `/historico/${equipamento}`,
                locationFunction: ()=> {changePage(`/historico/${equipamento}`)},
                active: true,
                disabled: false
            }
        )
        Reports.push(
            {
                icon: CompararIcon,
                text: t("reports.sub-items.charts.sidebar-title"),
                page: '/historico/graphs',
                locationFunction : ()=>{changePage(`/historico/graphs`)},
                active: true,
                disabled: false
            }
        )
        Reports.push(
            {
                type: 'separator'
            }
        )
        Reports.push(
            {
                type: 'separator'
            }
        )
        Reports.push(
            {
                type: 'close'
            }
        )
        Reports.push(
            {
                type: 'separator'
            }
        )
        Reports.push(
            {
                type: 'separator'
            }
        )
        Reports.push(
            {
                type: 'separator'
            }
        )


    let Maintenances = []
        Maintenances.push(
            {
                icon: MaintenanceIcon,
                text: 'Listagem',
                page: '/manutencoes',
                locationFunction: ()=> {changePage('/manutencoes')},
                active: user?.user?.can?.includes('maintenance.view'),
                disabled: !user?.user?.can?.includes('maintenance.view')
            }
        )
        Maintenances.push(
            {
                icon: ReportIcon,
                text: 'Relatórios',
                page: '/manutencoes/report',
                locationFunction: ()=> {changePage('/manutencoes/report')},
                active: user?.user?.can?.includes('maintenance.view'),
                disabled: !user?.user?.can?.includes('maintenance.view')
            }
        )
        Maintenances.push(
            {
                type: 'separator'
            }
        )
        Maintenances.push(
            {
                type: 'separator'
            }
        )
        Maintenances.push(
            {
                type: 'close'
            }
        )
        Maintenances.push(
            {
                type: 'separator'
            }
        )
        Maintenances.push(
            {
                type: 'separator'
            }
        )
        Maintenances.push(
            {
                type: 'separator'
            }
        )

    return (
        <>
            <Container $isExpanded={isExpanded} onClick={toggleExpanded}>
                <SvgIcon src={Menu}/>
            </Container>

            <ExpandedContent $show={isExpanded}>
            
            {/* --Primeira página do menu */}
                <ItemContainer icon={ControlIcon} select={currentPage.includes('/controle')} active={true} text={'Controle'} 
                    ClickFunction={()=> equipamento? changePage(`/controle/${equipamento}`) : changePage(`/controle`)}
                    page={equipamento ? `/controle/${equipamento}` : `/controle`} disabled={false} />
                <ItemContainer icon={ReportIcon} active={true} text={'Relatórios'}  disabled={false}
                    select={currentPage.includes('/historico')} ClickFunction={()=>ToggleSubitens(Reports)}
                />
                {/* Manutenção escondida temporariamente: módulo não está em uso (rotas /manutencoes continuam ativas) */}
                {/* <ItemContainer icon={MaintenanceIcon} select={currentPage.includes('/manutencoes')} 
                    active={true} text={'Manutenções'} 
                     ClickFunction={()=>ToggleSubitens(Maintenances)} disabled={false}/> */}

                <ItemContainer icon={DashIcon} active={true} text={'Dashboard'} select={currentPage.includes('/dashboard')}
                    ClickFunction={()=>ToggleSubitens(Dashboard)} disabled={false}/>

                {/* Célula vazia no lugar de Manutenção, para manter o botão de fechar no centro da grade 3x3 */}
                <ItemContainer />

                {/* <ItemContainer icon={DashIcon} active={true} text={'Dashboard'} select={currentPage.includes('/dashboard')}
                    ClickFunction={()=> equipamento? changePage(`/dashboard/${equipamento}`) : changePage(`/dashboard`)} page={'/dashboard'}/> */}

                <ItemContainer active={true} ClickFunction={toggleExpanded} disabled={false} >
                    <ContainerCenter src={CenterMobile} />   
                </ItemContainer>
                <ItemContainer icon={MapIcon} active={true} select={currentPage === '/'} text={'Mapa'} ClickFunction={()=> changePage('/')} page={'/'} disabled={false}/>
                <ItemContainer icon={SBDIcon} text={t("sidebar.SBD-home")} ClickFunction={() => window.location = 'https://webio.biosolvit.com/'} page = {'https://webio.biosolvit.com/'} active={true} disabled={false}/>
                <ItemContainer icon={AdmIcon} active={true} text={'Administrativo'} disabled={Administrativo.length < 1}
                    select={currentPage.includes('/funcionarios') || currentPage.includes('/equipamentos')
                    || currentPage.includes('/alocacoes') || currentPage.includes('/grupos') || currentPage.includes('/logs')}
                    ClickFunction={()=>ToggleSubitens(Administrativo)}
                />
                <ItemContainer icon={GoIcon} text={'Próxima Pag'} ClickFunction={TogglePageMenu} active={true} disabled={false}/>
                
                {/* --segunda página do menu */}
                <SubitensContainer $show={showPageMenu} $notShow={isExpanded}>
                    <ItemContainer icon={UserIcon}  text={'Meu Perfil'} active={true} disabled={false} select={currentPage === '/perfil'} ClickFunction={()=> changePage('/perfil')} page={'/perfil'}/>
                    <ItemContainer icon={OpenIcon}  text={'Irís'} />
                    <ItemContainer icon={LogOutIcon}  text={'Sair'} active={true} disabled={false} ClickFunction={()=> Leave()}/>      
                    <ItemContainer />
                    <ItemContainer  ClickFunction={toggleExpanded} active={true} disabled={false} >
                        <ContainerCenter src={CenterMobile} />   
                    </ItemContainer>
                    <ItemContainer />
                    <ItemContainer />
                    <ItemContainer />
                    <ItemContainer icon={BackIcon} text={'Voltar'} ClickFunction={hidePageMenu} active={true} disabled={false}/>
                </SubitensContainer>

                {/* --subitens */}
                <SubitensContainer $show={showSubitens}>
                    {itenstoShow.map((item, index) => (
                        item.type !== 'close' ? (
                            <ItemContainer
                                select={currentPage.includes(item.page)}
                                key={index}
                                icon={item.icon}
                                text={item.text}
                                ClickFunction={item.locationFunction}
                                active={item.active}
                                page={item.page}
                                disabled={item.disabled}
                            />
                        ) : (
                            <ItemContainer
                                active={true}
                                ClickFunction={toggleExpanded}
                                key={index}
                                disabled={false}
                            >
                                <ContainerCenter src={CenterMobile} />
                            </ItemContainer>
                        )
                    ))}
                    {showSubitens?
                        <ItemContainer icon={BackIcon} text={'Voltar'} ClickFunction={hideSubItens} active={true} disabled={false}/>
                    :
                        <></>
                    }
                </SubitensContainer>
            </ExpandedContent>
    
        </>
    );
}

export default MenuButton;
